import { connect } from "react-redux";
import { useParams, useRouteMatch } from "react-router";
import { useLazyQuery } from "@apollo/client";

import { getHeatsAndSchedulePosition } from "components/events/helpers";
import { GET_CURRENT_HEATS } from "graphql/event";
import { newManageEventPagesPath } from "components/application";
import * as EventActions from "actions/event";
import { RemoteControl } from "./RemoteControl";

export const EventRemoteControl = connect(state => ({ events: state.events }))(({ events, dispatch }) => {
    const { id } = useParams();
    const { data, refetch } = useLazyQuery(GET_CURRENT_HEATS, { variables: { id }, fetchPolicy: "cache-and-network", nextFetchPolicy: "cache-first" })[1];
    const newEventManagementPathMatch = useRouteMatch(newManageEventPagesPath);

    if (newEventManagementPathMatch) return (
        <RemoteControl
            loadHeats={refetch}
            heats={data?.event?.currentHeats.map(heat => ({
                ...heat,
                athletes: heat.competitors.reduce((athletes, competitor) => {
                    athletes[competitor.athleteId] = { ...competitor, name: competitor.athlete.name };
                    return athletes;
                }, {}),
                division: heat.eventDivision.division.name,
                number: heat.position + 1,
                type: heat.config.runBased ? "run" : "heat"
            })) || []}
            schedulePosition={data?.event?.currentScheduleIndex}
        />
    );

    return (
        <RemoteControl
            loadHeats={() => dispatch(EventActions.getCurrentHeats(id))}
            {...getHeatsAndSchedulePosition({ events }, { match: { params: { id } } })}
        />
    );
});
